module.exports = __webpack_public_path__ + "static/media/pasta.7b51d29f.png";